import { Group, Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useCallback, useEffect } from "react";
import { useDispatch } from "src/redux/hooks";
import { useParams } from "react-router-dom";
import { Button } from "src/components/shared/Button/Button";
import { useSelector } from "src/redux/hooks";
import { setOpenedRefetchModal } from "src/redux/slices/entrySlice";

import { usePostApi } from "../../../hooks";

interface Props {
  refetch: () => void;
}

const RefetchModal = ({ refetch }: Props) => {
  const [opened, { open, close }] = useDisclosure(false);
  const dispatch = useDispatch();
  const { post } = usePostApi();
  const { editing, changed, you } = useSelector(state => state.entrySlice);
  const { logbookId, lbeidOrPartId } = useParams();

  useEffect(() => {
    if (changed && !you) {
      open();
    }
  }, [editing, changed, open]);

  useEffect(() => {
    dispatch(setOpenedRefetchModal(opened));
  }, [dispatch, opened]);

  const handleSubmit = async () => {
    await post({
      request: "acknowledge-latest-changes",
      body: {
        params: {
          lbid: logbookId,
          rid: lbeidOrPartId,
        },
      },
    });
    refetch();
    close();
  };

  return (
    <Modal
      opened={opened}
      zIndex={11}
      onClose={handleSubmit}
      withCloseButton={false}
      centered>
      <Text align="center">
        Another user has edited this entry! It will be automatically updated now
        to ensure you have the most up to date version.
      </Text>
      <Group mt="lg">
        <Button mx="auto" onClick={handleSubmit}>
          OK
        </Button>
      </Group>
    </Modal>
  );
};

export default RefetchModal;
